export const STREAM_SECTION_TYPES = [
  { value: 'scheduleCalendar', label: 'Schedule calendar', icon: 'fas fa-calendar' },
  { value: 'aboutStream', label: 'About stream', icon: 'fas fa-broadcast-tower' },
  { value: 'features', label: 'Features & subs', icon: 'fas fa-gem' },
  { value: 'setup', label: 'Streaming setup', icon: 'fas fa-desktop' },
  { value: 'customTables', label: 'Custom tables', icon: 'fas fa-table' },
  { value: 'description', label: 'Description', icon: 'fas fa-align-left' },
  { value: 'video', label: 'Video', icon: 'fas fa-play-circle' },
  { value: 'faq', label: 'FAQ', icon: 'fas fa-question-circle' },
  { value: 'cta', label: 'Call to action', icon: 'fas fa-hand-pointer' },
];

export const COLUMN_STYLES = [
  { value: 'text', label: 'Plain text' },
  { value: 'command', label: 'Command chip' },
  { value: 'mono', label: 'Monospace chip' },
  { value: 'permission', label: 'Permission badge' },
  { value: 'highlight', label: 'Highlight text' },
];

export function slugifyColumnKey(value) {
  return String(value || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_|_$/g, '') || 'column';
}

export function defaultTableBlock(overrides = {}) {
  return {
    heading: 'Sound',
    highlight: 'FX',
    intro: '',
    separatorBefore: false,
    separatorLabel: '',
    collapsible: true,
    defaultOpen: true,
    columns: [
      { key: 'command', label: 'Command', style: 'command' },
      { key: 'permission', label: 'Permission', style: 'permission' },
      { key: 'description', label: 'Description', style: 'text' },
      { key: 'example', label: 'Example', style: 'mono' },
    ],
    rows: [
      { command: '!meme', permission: 'EVERYONE', description: 'Play a meme sound.', example: '!meme' },
    ],
    ...overrides,
  };
}

export function getSectionTypeMeta(type) {
  return STREAM_SECTION_TYPES.find((t) => t.value === type) || { value: type, label: type, icon: 'fas fa-cube' };
}

export function getSectionSummary(section) {
  const meta = getSectionTypeMeta(section.type);
  const title = [section.heading, section.highlight].filter(Boolean).join(' ');
  if (title) return title;
  if (section.type === 'features') return `${meta.label} (${(section.features || []).length} items)`;
  if (section.type === 'setup') return `${meta.label} (${(section.setupCategories || []).length} categories)`;
  if (section.type === 'customTables') return `${meta.label} (${(section.tables || []).length} tables)`;
  if (section.type === 'faq') return `${meta.label} (${(section.items || []).length} items)`;
  return meta.label;
}

export function defaultSection(type) {
  switch (type) {
    case 'scheduleCalendar':
      return {
        type,
        heading: 'Stream',
        highlight: 'Schedule',
        intro: '',
        footnote: '',
        tbcNote: '',
        specialEventsNote: '',
      };
    case 'aboutStream':
      return {
        type,
        heading: 'About My',
        highlight: 'Stream',
        youtubeHeading: 'YouTube - Pure Gameplay Experience',
        youtubeParagraphs: [''],
        twitchHeading: 'Twitch - Interactive Fun',
        twitchParagraph: '',
        expectHeading: 'What to Expect:',
        expectItems: [{ label: '', text: '' }],
        supportText: '',
      };
    case 'features':
      return {
        type,
        heading: 'Stream Features &',
        highlight: 'Subscriber Benefits',
        features: [{ icon: 'fas fa-gem', iconColor: '#ffb400', title: '', description: '' }],
      };
    case 'setup':
      return {
        type,
        heading: 'My',
        highlight: 'Streaming Setup',
        intro: '',
        setupCategories: [{ emoji: '🎮', name: 'Category', items: [{ label: '', text: '' }] }],
        triplePcHeading: 'Triple PC Setup',
        pcSpecs: [],
        streamingCommunicationHeading: 'Streaming Communication',
        streamingCommunication: [],
      };
    case 'customTables':
      return {
        type,
        intro: '',
        tables: [
          defaultTableBlock(),
          defaultTableBlock({
            heading: 'Video',
            highlight: 'FX',
            separatorBefore: true,
            separatorLabel: '// VIDEO_FX',
            rows: [{ command: '!clip', permission: 'MOD', description: 'Create a clip.', example: '!clip' }],
          }),
        ],
      };
    case 'description':
      return { type, heading: 'Section', highlight: '', paragraphs: [''] };
    case 'video':
      return { type, heading: 'Video', highlight: '', youtubeId: '', title: '' };
    case 'faq':
      return { type, heading: 'FAQ', highlight: 'Questions', items: [{ question: '', answer: '', isList: false, listItems: [] }] };
    case 'cta':
      return {
        type,
        heading: 'Ready to',
        highlight: 'Get Started?',
        buttons: [{ href: '', text: '', icon: 'fas fa-link', variant: 'primary', primary: true, external: false }],
        beta: null,
      };
    default:
      return { type: 'description', heading: '', highlight: '', paragraphs: [] };
  }
}

export const emptyPage = () => ({
  slug: '',
  title: '',
  navLabel: '',
  showInNav: true,
  isSystem: false,
  seo: { description: '', keywords: '', url: '' },
  hero: { title: '', highlight: '', subtitle: '', image: '' },
  content: { sections: [] },
  published: true,
  sortOrder: 0,
});

export function streamPagePublicPath(slug) {
  return `/stream-${slug}`;
}
